import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { sendPasswordResetCode } from 'store/actions/resetPassword';
import { fetchReset } from 'store/actions/entities';
import Stage1 from 'components/ResetPasswordStages/Stage1/index';

export default withTranslation()(
  connect(null, { sendPasswordResetCode, fetchReset })(Stage1),
);
